import { Container } from "@mui/system";
import { useEffect, useState } from "react";
import CategorizedJobList from "../Sections/CategorizedJobList";

type Props = {
  jobs: any[];
  offerDeadlineText: any;
};

const JobCategories = ({ jobs, offerDeadlineText }: Props) => {
  const [jobTypes, setJobTypes] = useState<Array<string>>([]);

  useEffect(() => {
    setJobTypes([...new Set(jobs.map((item: any) => item.projectType))]);
  }, [jobs]);

  return (
    <Container
      sx={{
        width: { lg: "1248px !important", xs: "98vw" },
        display: "flex",
        flexDirection: "column",
        gap: 5,
      }}
    >
      {jobTypes.map((type: string) => {
        return <CategorizedJobList key={type} type={type} jobs={jobs} />;
      })}
    </Container>
  );
};

export default JobCategories;
